export const role = {
    ADMIN: 'ADMIN',
    SUPERVISOR: 'SUPERVISOR',
    AGENT: 'AGENT',
};

export const allRoles = Object.values(role);
